import React from 'react';
import classNames from 'classnames';
const PillsMenuItem = ({ text, onClick, selected, dotColor }) => {
    return (<button onClick={onClick} className={classNames('btn pills-menu-item', { selected })}>
            {text}
            {dotColor && <div className={`dot bg-${dotColor}`}/>}
        </button>);
};
export default PillsMenuItem;
